import { render, staticRenderFns } from "./ProfileRoadMap.vue?vue&type=template&id=67443cad&"
import script from "./ProfileRoadMap.vue?vue&type=script&lang=js&"
export * from "./ProfileRoadMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports